import { Pipe, PipeTransform } from '@angular/core';
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from "@progress/kendo-data-query";

@Pipe({
  name: 'filterPipe'
})
export class FilterPipePipe implements PipeTransform {

  transform(value: CompositeFilterDescriptor, ...args: unknown[]): unknown {
    console.log(value);
    if (value.filters.length > 0) {
      return (value.filters[0] as FilterDescriptor).value;
    }
    return undefined;
  }

}
